import { openModal } from "action/modal/openModal";
import { LogIn } from "lucide-react";
import { useTranslation } from "next-i18next";
import { useDispatch } from "react-redux";
// import PAButton, { BUTTON_SIZE } from "../../../component/design-system/buttons/PAButton";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import SharedStyles from "./shared-style.module.scss";

function AccountOverviewNotSignedIn() {
  const dispatch = useDispatch();
  // const { t } = useTranslation("home", { keyPrefix: "personalization" });
  const { t } = useTranslation("home");

  function login() {
    dispatch(openModal("login", {}));
  }
  function signUp() {
    dispatch(openModal("signup", {}));
  }

  return (
    <div className={SharedStyles.signInSignUp}>
      <div className="d-flex justify-content-between align-items-end">
        <div onClick={login} className="d-flex flex-column">
          <PAText
            fontSize={FONT_SIZE[2]}
            bold
            className={`m-0 p-b-5 ${SharedStyles.click_link}`}
          >
            {t("Sign in")}
            <LogIn size={20} className={SharedStyles.signInIcon} aria-hidden="true" />
          </PAText>
          <PAText color="light-grey" fontSize={FONT_SIZE[0]} className="m-0">{t("for best experience")}</PAText>
        </div>

        <div onClick={signUp} className="d-flex flex-column">
          <PAText
            fontSize={FONT_SIZE[2]}
            bold
            className={`m-0 p-b-5 ${SharedStyles.click_link}`}
          >
            {t("Sign Up")}
          </PAText>
          <PAText color="light-grey" fontSize={FONT_SIZE[0]} className="m-0">{t("New customer?")}</PAText>
        </div>
      </div>
    </div>
  );
}

export default AccountOverviewNotSignedIn;
